import { ReactElement } from "react"

import AmendAcuDeviceForm from "../../../../components/devices/lct/acu/amendAcuDeviceForm"
import ContinueAcuDeviceAmendmentProvider from "../../../../components/devices/lct/acu/providers/continueAcuDeviceAmendmentProvider"

const ContinueAcuDraftDeviceAmendment = (): ReactElement => (
    <ContinueAcuDeviceAmendmentProvider>
        <AmendAcuDeviceForm />
    </ContinueAcuDeviceAmendmentProvider>
)

export default ContinueAcuDraftDeviceAmendment
